<div class="mbrl15 martb0">
	<div class="row">
		<div class="col-12">
			<div class="input-group input-group-sm mb-10">
				<input
					type="text"
					class="form-control almnabrformcontrol"
					(keyup)="getTypeList()"
					[(ngModel)]="searchKey"
					placeholder="{{ 'lang_search' | language }}"
				/>
				<span class="input-group-btn">
					<button
						class="btnSearch h34 btn btn-md btn-gray fa fa-plus mnabricon"
						id="btnSearch"
						(click)="onAddEditType()"
						type="button"
						matTooltip="{{ 'lang_add' | language }}"
					></button>
				</span>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12">
			<div class="table-responsive dropdownyes customResponsive">
				<table border="1" class="table CustomTable">
					<thead>
						<tr>
							<td>#</td>
							<td>{{ "lang_title_english" | language }}</td>
							<td>{{ "lang_title_arabic" | language }}</td>
							<td>{{ "lang_action" | language }}</td>
						</tr>
					</thead>
					<tbody *ngIf="typeList?.length != 0" class="AppendList">
						<tr
							*ngFor="
								let row of typeList;
								let i = index;
								let odd = odd;
								let even = even
							"
							[ngClass]="{ odd: odd, even: even }"
						>
							<td>{{ i + 1 }}</td>
							<td>{{ row.quotation_types_name_en }}</td>
							<td>{{ row.quotation_types_name_ar }}</td>
							<td>
								<i
									class="fa fa-cog mnabricon"
									[matMenuTriggerFor]="menu"
									matTooltip="{{ 'lang_settings' | language }}"
								></i>
								<mat-menu #menu="matMenu">
									<button
										mat-menu-item
										class="d-flex justify-content-center align-items-center"
										(click)="onAddEditType(row)"
									>
										<span>{{ "lang_edit" | language }}</span>
										<i
											class="fa fa-pencil-square-o ml-1 mr-1 fa-icon mnabricon"
										></i>
									</button>
									<button
										mat-menu-item
										class="d-flex justify-content-center align-items-center"
										(click)="deleteType(row?.quotation_types_id)"
									>
										<span>{{ "lang_delete" | language }}</span>
										<i class="fa fa-trash ml-1 mr-1 fa-icon red"></i>
									</button>
								</mat-menu>
							</td>
						</tr>
					</tbody>
					<tbody *ngIf="typeList?.length == 0" class="AppendList">
						<tr class="odd">
							<td colspan="10" align="center">{{ nodata }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>
